import { copies, deliveryMethodNames } from '@reveni-io/reveni-ui'

import { copyGroups, copyInputTypes, getCopyTabs, miscPreviewSections } from './constants'

const stripHtmlTags = text => text?.replace(/<[^>]*>/g, '') || ''

const getMiscCopies = () => [
  {
    key: miscPreviewSections.orderNumber,
    group: copyGroups.misc,
    copyType: copyInputTypes.text,
    label: lang => copies[lang].texts.orderNumber,
    placeholder: lang => copies[lang].texts.orderNumber,
  },
  {
    key: miscPreviewSections.emailPostcode,
    group: copyGroups.misc,
    copyType: copyInputTypes.text,
    label: lang => copies[lang].texts.emailOrPostCode,
    placeholder: lang => copies[lang].texts.emailOrPostCode,
  },
  {
    key: miscPreviewSections.variants,
    group: copyGroups.misc,
    copyType: copyInputTypes.text,
    label: lang => copies[lang].texts.variants,
    placeholder: lang => copies[lang].texts.variants,
  },
  {
    key: miscPreviewSections.otherProducts,
    group: copyGroups.misc,
    copyType: copyInputTypes.text,
    label: lang => copies[lang].texts.otherProduct,
    placeholder: lang => copies[lang].texts.otherProduct,
  },
  {
    key: miscPreviewSections.outOfStock,
    group: copyGroups.misc,
    copyType: copyInputTypes.text,
    label: lang => copies[lang].texts.productNotAvailable,
    placeholder: lang => copies[lang].texts.productNotAvailable,
  },
]

const getBlockedProductCopies = () => [
  {
    key: 'error.item_disabled',
    group: copyGroups.blockedProducts,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: () => 'Producto bloqueado',
    placeholder: lang => copies[lang].errors.itemDisabled.title,
    textareaPlaceholder: (lang, merchant) => copies[lang]?.errors?.itemDisabled?.plainText(merchant),
  },
  {
    key: 'error.item_too_old',
    group: copyGroups.blockedProducts,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.itemTooOld.title,
    placeholder: lang => copies[lang].errors.itemTooOld.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.itemTooOld.plainText(merchant),
  },
  {
    key: 'error.item_unfulfilled',
    group: copyGroups.blockedProducts,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: () => 'Producto sin enviar',
    placeholder: lang => copies[lang].errors.itemUnfulfilled.title,
    textareaPlaceholder: (lang, merchant) => copies[lang]?.errors?.itemUnfulfilled?.plainText(merchant),
  },
  {
    key: 'error.item_not_enough_quantity',
    group: copyGroups.blockedProducts,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: () => 'Producto devuelto anteriormente',
    placeholder: lang => copies[lang].errors.notEnoughQuantity.title,
    textareaPlaceholder: (lang, merchant) => copies[lang]?.errors?.notEnoughQuantity?.plainText(merchant),
  },
  {
    key: 'error.item_no_variants',
    group: copyGroups.blockedProducts,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: () => 'Producto sin variantes',
    placeholder: lang => copies[lang].errors.noVariants.title,
    textareaPlaceholder: (lang, merchant) => copies[lang]?.errors?.noVariants?.plainText(merchant),
  },
]

const getErrorDialogCopies = () => [
  {
    key: 'error.order_not_found',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.default.title,
    placeholder: lang => copies[lang].errors.default.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.default.plainText(merchant),
  },
  {
    key: 'error.order_cancelled',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.cancelled.title,
    placeholder: lang => copies[lang].errors.cancelled.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.cancelled.plainText(merchant),
  },
  {
    key: 'error.disabled_by_rule',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: () => 'Pedido bloqueado',
    placeholder: lang => copies[lang].errors.disabledByRule.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.disabledByRule.plainText(merchant),
  },
  {
    key: 'error.from_previous_exchange',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: () => 'Pedido de cambio previo',
    placeholder: lang => copies[lang].errors.reveniExchange.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.reveniExchange.plainText(merchant),
  },
  {
    key: 'error.order_no_amount',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.noAmount.title,
    placeholder: lang => copies[lang].errors.noAmount.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.noAmount.plainText(merchant),
  },
  {
    key: 'error.order_with_giftcard',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.disabledGiftcard.title,
    placeholder: lang => copies[lang].errors.disabledGiftcard.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.disabledGiftcard.plainText(merchant),
  },
  {
    key: 'error.has_external_returns',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.externalReturns.title,
    placeholder: lang => copies[lang].errors.externalReturns.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.externalReturns.plainText(merchant),
  },
  {
    key: 'error.order_disabled_channel',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: () => 'Canal de venta',
    placeholder: lang => copies[lang].errors.disabledChannel.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.disabledChannel.plainText(merchant),
  },
  {
    key: 'error.order_region_not_allowed',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.regionNotAllowed.title,
    placeholder: lang => copies[lang].errors.regionNotAllowed.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.regionNotAllowed.plainText(merchant),
  },
  {
    key: 'error.order_pending_payment',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.pendingPayment.title,
    placeholder: lang => copies[lang].errors.pendingPayment.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.pendingPayment.plainText(merchant),
  },
  {
    key: 'error.order_with_chargeback',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.chargeback.title,
    placeholder: lang => copies[lang].errors.chargeback.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.chargeback.plainText(merchant),
  },
  {
    key: 'error.exchange_not_allowed',
    group: copyGroups.errorDialogs,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: true,
    label: lang => copies[lang].errors.exchangeNotAllowed.title,
    placeholder: lang => copies[lang].errors.exchangeNotAllowed.title,
    textareaPlaceholder: (lang, merchant) => copies[lang].errors.exchangeNotAllowed.plainText(merchant),
  },
]

const getDeliveryMethodCopies = () => [
  {
    key: 'delivery_method.customerpickup',
    group: copyGroups.deliveryMethods,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: false,
    hideInput: true,
    label: () => deliveryMethodNames.customerpickup,
    textareaPlaceholder: lang => copies[lang]?.returnMethods?.customerpickup || '',
  },
  {
    key: 'delivery_method.pickuppoint',
    group: copyGroups.deliveryMethods,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: false,
    hideInput: true,
    label: () => deliveryMethodNames.pickuppoint,
    textareaPlaceholder: lang => copies[lang]?.returnMethods?.pickuppoint || '',
  },
  {
    key: 'delivery_method.returntostore',
    group: copyGroups.deliveryMethods,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: false,
    hideInput: true,
    label: () => deliveryMethodNames.returntostore,
    textareaPlaceholder: lang => copies[lang]?.returnMethods?.returntostore || '',
  },
  {
    key: 'delivery_method.customerdelivers',
    group: copyGroups.deliveryMethods,
    copyType: copyInputTypes.titleAndTextArea,
    useHtmlInTextArea: false,
    hideInput: true,
    label: () => deliveryMethodNames.customerdelivers,
    textareaPlaceholder: lang => copies[lang]?.returnMethods?.customerdelivers || '',
  },
]

const getRequestSummaryCopies = () => [
  {
    key: 'summary.instant_refund.bank_transfer',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Reembolso instantáneo: Transferencia bancaria instantánea',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.instantRefundBankTransfer),
  },
  {
    key: 'summary.instant_refund.original_payment_method',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Reembolso instantáneo: Método de pago original',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.instantRefundOriginalPaymentMethod),
  },
  {
    key: 'summary.instant_refund.gift_card',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Reembolso instantáneo: Tarjeta regalo',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.instantRefundGiftCard),
  },
  {
    key: 'summary.instant_refund.store_credit',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Reembolso instantáneo: Crédito en tienda',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.instantRefundStoreCredit),
  },
  {
    key: 'summary.refund.original_payment_method',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Reembolso: Método de pago original',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.refundOriginalPaymentMethod),
  },
  {
    key: 'summary.refund.gift_card',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Reembolso: Tarjeta regalo',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.refundGiftCard),
  },
  {
    key: 'summary.refund.store_credit',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Reembolso: Crédito en tienda',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.refundStoreCredit),
  },
  {
    key: 'summary.instant_exchange',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Cambio instantáneo',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.instantExchange),
  },
  {
    key: 'summary.exchange',
    group: copyGroups.requestSummary,
    copyType: copyInputTypes.richText,
    label: () => 'Cambio',
    textareaPlaceholder: lang => stripHtmlTags(copies[lang]?.requestSummary?.exchange),
  },
]

export const allCopies = [
  ...getBlockedProductCopies(),
  ...getErrorDialogCopies(),
  ...getDeliveryMethodCopies(),
  ...getRequestSummaryCopies(),
  ...getMiscCopies(),
]

export const getCopiesByGroup = group => allCopies.filter(copy => copy.group === group)

const buildEmptyValue = copy => {
  if (copy.copyType === copyInputTypes.text) return ''
  if (copy.copyType === copyInputTypes.richText) return { message: '' }
  if (copy.hideInput) return { message: '' }

  return { title: '', message: '' }
}

const buildNullValue = copy => {
  if (copy.copyType === copyInputTypes.text) return null
  if (copy.copyType === copyInputTypes.richText) return { message: null }
  if (copy.hideInput) return { message: null }

  return { title: null, message: null }
}

const buildPersistedValue = (copy, payload) => {
  if (copy.copyType === copyInputTypes.text) return payload.message
  if (copy.copyType === copyInputTypes.richText) return { message: payload.message }
  if (copy.hideInput) return { message: payload.message }

  return { title: payload.title, message: payload.message }
}

export const flattenCustomCopies = (customCopies, allCopies) => {
  const result = {}

  if (!customCopies) return result

  const copiesByKey = new Map(allCopies.map(c => [c.key, c]))

  Object.entries(customCopies).forEach(([lang, langCopies]) => {
    result[lang] = {}

    langCopies.forEach(payload => {
      const copy = copiesByKey.get(payload.key)
      if (!copy) return

      result[lang][payload.key] = buildPersistedValue(copy, payload)
    })
  })

  return result
}

export const initCopyValue = copy => buildEmptyValue(copy)

const getMessage = value =>
  typeof value === 'string' || value === null || value === undefined ? value : value?.message

const getTitle = value => (typeof value === 'object' && value !== null ? value.title : undefined)

const buildPayloadItem = (copy, value) => {
  const message = getMessage(value) ?? null
  const item = { key: copy.key, message }

  if (copy.copyType === copyInputTypes.titleAndTextArea && !copy.hideInput) {
    item.title = getTitle(value) ?? null
  }

  return item
}

export const getPayload = (customCopies, allCopies) => {
  const result = {}
  const copiesByKey = new Map(allCopies.map(c => [c.key, c]))

  for (const [lang, langCopies] of Object.entries(customCopies)) {
    result[lang] = []

    for (const [fullKey, value] of Object.entries(langCopies)) {
      const copy = copiesByKey.get(fullKey)
      if (!copy) continue

      result[lang].push(buildPayloadItem(copy, value))
    }
  }

  return result
}

export const setToNullDisabledCopies = (disabledKeys, languages, customCopies, allCopies) => {
  const copiesByKey = new Map(allCopies.map(c => [c.key, c]))

  languages.forEach(lang => {
    if (!customCopies[lang]) return

    disabledKeys.forEach(fullKey => {
      if (!(fullKey in customCopies[lang])) return

      const copy = copiesByKey.get(fullKey)
      if (!copy) return

      customCopies[lang][fullKey] = buildNullValue(copy)
    })
  })

  return customCopies
}

const isAValidCopy = (copy, value) => {
  if (copy.copyType === copyInputTypes.text) return !!value
  if (copy.copyType === copyInputTypes.richText) return !!getMessage(value)
  if (copy.hideInput) return !!getMessage(value)

  return !!getTitle(value) && !!getMessage(value)
}

export const getErrors = (customCopies, availableLanguages, disabledKeys, allCopies) => {
  let errors = {}
  const copiesByKey = new Map(allCopies.map(c => [c.key, c]))

  availableLanguages.forEach(lang => {
    const langCopies = customCopies[lang] || {}

    Object.entries(langCopies).forEach(([fullKey, value]) => {
      if (disabledKeys.includes(fullKey)) return

      const copy = copiesByKey.get(fullKey)
      if (!copy) return

      if (!isAValidCopy(copy, value)) {
        errors = {
          ...errors,
          [lang]: {
            ...errors[lang],
            [fullKey]: true,
          },
        }
      }
    })
  })

  return errors
}

const hasErrorsForKeys = (errors, keys) => Object.values(errors).some(langErrors => keys.some(key => langErrors[key]))

export const getTabsWithErrors = (t, errors, allCopies) =>
  getCopyTabs(t).map(tab => {
    const groupKeys = allCopies.filter(copy => copy.group === tab.value).map(copy => copy.key)
    return { ...tab, error: hasErrorsForKeys(errors, groupKeys) }
  })

export const focusOnError = errors => {
  const languages = Object.keys(errors)
  const keyError = Object.keys(errors[languages[0]])?.[0]
  const element = document.getElementById(keyError)

  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

export const buildMerchantInfo = (store, customerContactMethod) => {
  return {
    name: store?.name,
    contact_email: store?.contact_email,
    contact_url: store?.contact_url,
    preferences: { contact_method: customerContactMethod },
  }
}
